import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
      path: "/why",
      component: () =>
          import ('../views/why')
  },
  {
      path: "/our",
      component: () =>
          import ('../views/our')
  },
  {
      path: "/who",
      component: () =>
          import ('../views/who')
  },
  {
      path: "/mining",
      component: () =>
          import ('../views/mining')
  },
  {
      path: "/appliction",
      component: () =>
          import ('../views/appliction')
  },
  {
      path: "/cement",
      component: () =>
          import ('../views/cement')
  },
  {
      path: "/powerplant",
      component: () =>
          import ('../views/powerplant')
  },
  {
      path: "/bimetal",
      component: () =>
          import ('../views/bimetal')
  },
  {
      path: "/steelmill",
      component: () =>
          import ('../views/steelmill')
  },
  {
      path: "/bulk-material",
      component: () =>
          import ('../views/bulk-material')
  },
  {
      path: "/nihard",
      component: () =>
          import ('../views/nihard')
  },
  {
      path: "/welding",
      component: () =>
          import ('../views/welding')
  },
  {
      path: "/wear",
      component: () =>
          import ('../views/wear')
  },
  {
      path: "/detail",
      component: () =>
          import ('../views/detail')
  },
  {
      path: "/port",
      component: () =>
          import ('../views/port')
  },
  {
      path: "/cco",
      component: () =>
          import ('../views/cco')
  },
  {
      path: "/contact",
      component: () =>
          import ('../views/contact')
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }), 
  routes
});

export default router;
